import { Box } from "@mui/material";
import PkCommonArrow from "../../../components/common/PkCommonArrow";
import { getLayoutText } from "../../../components/layout/getLayoutText";
import { getLayoutLead } from "../../../components/layout/getLayoutLead";
import { getLayoutView } from "../../../components/layout/getLayoutView";
export function Works() {
  return (
    <Box sx={{ backgroundColor: "white" }}>
      {getLayoutLead(
        <>
          Join our contributor community and enjoy several benefits, including
          support, promotion, and profit sharing. Help make Polycaik the premier
          platform for content for a diversified culture.
        </>,
        { fontSize: "1.5rem" }
      )}
      <PkCommonArrow color={"white"} />
      {getLayoutView(
        <>
          FEATURED{" "}
          <span style={{ fontFamily: "Lato-Bold" }}>CONTRIBUTORS </span>
        </>,
        [
          getLayoutText(
            <>
              Great talent is hard to find. We want to take the time to
              acknowledge a few exceptional people who have contributed to the
              development of the Polycaik platform.
            </>,
            { fontSize: "1.5rem", fontFamily: "Lato-Regular" }
          ),
        ],
        [12],
        {
          p: `8rem 10%`,
          backgroundColor: (theme) => theme.palette.grey[800],
          "& .MuiTypography-root:not(.MuiTypography-caption)": {
            color: (theme) => theme.palette.grey[100],
          },
        }
      )}
      <PkCommonArrow color={(theme) => theme.palette.grey[800]} />
    </Box>
  );
}
